import { useNuxtApp } from "#app";
export function useHead(input, options) {
  return useNuxtApp()._useHead(input, options);
}
